import { useState } from "react";

import { useMergeOrganisationsMutation } from "@sso/apis/organisations";
import { Select, SelectDataType } from "@sso/components/Form";
import { DialogTitle } from "@sso/constant";
import { useAppDispatch, useAppSelector } from "@sso/hooks/useRedux";
import { clearOrganisationMergeArray, selectMergeOrganisations } from "@sso/store/slices/organisation";
import { MergeOrgsRequest } from "@sso/types";
import { Typography } from "@sso/ui/Typography";

import { DialogActionButtons, DialogBody, DialogHeader } from "../components";

export const MergeOrganisationsDialog = () => {
  const dispatch = useAppDispatch();

  const mergeOrgArray = useAppSelector(selectMergeOrganisations);
  const mergeOrgsOption: SelectDataType[] = mergeOrgArray.map(org => ({ key: org.id, value: org.name, label: org.name }));

  const [masterOrg, setMasterOrg] = useState<SelectDataType | undefined>(mergeOrgsOption[0] || undefined);
  const [mergeOrganisations, { isLoading }] = useMergeOrganisationsMutation();

  const onOrgChange = (data: SelectDataType) => {
    setMasterOrg(data);
  };

  const handleRemoveMergeArray = () => dispatch(clearOrganisationMergeArray());

  const handleMergeOrgsAction = () => {
    if (!masterOrg) {
      return;
    }
    const organisationIds = mergeOrgArray.filter(org => org.id !== masterOrg.key).map(org => org.id);
    const data: MergeOrgsRequest = { organisationId: masterOrg.key as number, organisationIds };
    mergeOrganisations(data);
  };

  return (
    <>
      <DialogHeader title={DialogTitle.MERGE_ORGANISATIONS} />
      <DialogBody overflow="visible">
        <Typography padding="0 0 1.5rem 0">Please select the master organisation you want to merge into.</Typography>
        <Select
          label="Organisations"
          items={mergeOrgsOption}
          value={masterOrg}
          searchable
          clearable={false}
          onChange={onOrgChange}
        />
      </DialogBody>
      <DialogActionButtons
        loading={isLoading}
        buttonTitle={"Merge"}
        onClickAction={handleMergeOrgsAction}
        onClickCancel={handleRemoveMergeArray}
      />
    </>
  );
};
